import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";

import { Paths } from "@/core/constants/paths";
import styles from "./not-found-screen.module.scss";

export function NotFoundScreen() {
  const navigate = useNavigate();

  return (
    <div className={styles.page} data-testid="not-found-screen">
      <h1 className={styles.code}>404</h1>
      <p className={styles.message}>Página não encontrada</p>
      <Button type="button" label="Voltar ao início" onClick={() => navigate(Paths.HOME)} />
    </div>
  );
}
